import { Button, Flex, Layout, Modal, Table, Typography } from "antd";
import { motion } from "framer-motion";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { UserPlus } from "lucide-react";
import { useGetUsers } from "@hooks";
import { usersTable } from "../configurations/usersTable";
import { AddUserForm } from "../components/users/AddUserForm";

export const UsersPage = () => {
  const { data, isLoading } = useGetUsers();
  const { t } = useTranslation();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Layout>
        <Flex justify="space-between" align="center">
          <div style={{ display: "flex" }}>
            <div
              style={{
                width: 3,
                backgroundColor: "#F1B80E",
                borderRadius: 100,
                marginRight: 12,
              }}
            />
            <Typography.Title level={2} style={{ margin: 0 }}>
              {t("users")}
            </Typography.Title>
          </div>
          <Button
            type="primary"
            icon={<UserPlus size={18} />}
            onClick={() => setIsAddModalOpen(true)}
          >
            {t("forms.user.addUser")}
          </Button>
        </Flex>

        <div
          style={{
            boxShadow: "rgba(0, 0, 0, 0.16) 1px 0px 5px",
            borderRadius: "8px",
            marginTop: 12,
          }}
        >
          <Table
            size="middle"
            dataSource={data?.items}
            rowKey={(record) => record.id}
            loading={isLoading}
            style={{ borderRadius: "8px" }}
            columns={usersTable}
          />
        </div>

        <Modal
          title={t("forms.user.addUser")}
          open={isAddModalOpen}
          destroyOnClose
          footer={null}
          onCancel={() => setIsAddModalOpen(false)}
        >
          <AddUserForm setIsModalOpen={setIsAddModalOpen} />
        </Modal>
      </Layout>
    </motion.div>
  );
};
